import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
} from 'recharts';

const FeeCollectionProgress = ({ FeeData }) => {
  const [feeDetails, setFeeDetails] = useState([
    {
      name: 'TotalCollected',
      value: 0,
    },
    {
      name: 'FeeWriteOff',
      value: 0,
    },
    {
      name: 'RemainingDue',
      value: 0,
    },
  ]);
  const COLORS = [
    '#3EC043', //green - totalCollected
    // '#3468FF', //blue - totalDue
    '#e80e48', //Red - feeWriteOff
    '#3468FF', //blue - remainingDue
  ];
  useEffect(() => {
    const data = FeeData?.filter((obj) => {
      if (obj.name !== 'TotalFee' && obj.name !== 'TotalDue') {
        return obj;
      }
    });
    setFeeDetails(data || []);
  }, [FeeData]);
  return (
    <div className='bg-white rounded-lg shadow-md  size-full'>
      <div className='px-3 pt-2'>
        <Typography variant='h6'>Fee Summary</Typography>
      </div>

      {!feeDetails?.every((obj) => obj.value == 0) ? (
        <div className='overflow-auto'>
          <div className=' min-w-[300px] '>
            <ResponsiveContainer width='100%' height={230}>
              <PieChart>
                <Pie
                  data={feeDetails}
                  dataKey='value'
                  nameKey='name'
                  cx='50%'
                  cy='50%'
                  margin={{ top: 10, bottom: 10, left: 0, right: 10 }}
                  innerRadius={50}
                  outerRadius={80}
                  minAngle={5}
                >
                  {feeDetails?.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                  <Label
                    content={
                      <text
                        x='50%'
                        y='40%'
                        textAnchor='middle'
                        dominantBaseline='middle'
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        <tspan
                          x='50%'
                          style={{ fontSize: '16px', marginBottom: '10px' }}
                        >
                          Total Fee
                        </tspan>
                        <tspan x='50%' dy='20'>
                          {`₹${new Intl.NumberFormat('en-IN').format(FeeData?.[0]?.value ?? '--')}`}
                        </tspan>
                      </text>
                    }
                  />
                </Pie>
                <Tooltip
                  content={({ active, payload }) => {
                    if (!active || !payload || !payload.length) return null;
                    const formatted = new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(payload?.[0]?.value);

                    return (
                      <div className='bg-white border rounded shadow p-2 text-center min-w-[60px]'>
                        <div className='font-bold '>{payload?.[0]?.name}</div>
                        <div className='font-semibold text-black'>
                          {formatted}
                        </div>
                      </div>
                    );
                  }}
                />

                <Legend
                  content={
                    <div className=' flex'>
                      <div className=' w-1/2 '>
                        {' '}
                        <div className='flex gap-2 justify-center '>
                          <div className='w-5 h-3 rounded-full bg-[#3468FF] self-center'></div>{' '}
                          <div>Remaining Due</div>
                        </div>
                        {feeDetails?.[1]?.value > 0 && (
                          <div className='flex gap-2 justify-center pr-4'>
                            <div className='w-5 h-3 rounded-full bg-[#e80e48] self-center'></div>{' '}
                            <div>Fee WriteOff</div>
                          </div>
                        )}
                      </div>
                      <div className=' w-1/2'>
                        {' '}
                        <div className='flex justify-center gap-2'>
                          <div className='w-5 h-3 rounded-full bg-[#3EC043] self-center'></div>{' '}
                          <div className=''>Total collected</div>
                        </div>
                      </div>
                    </div>
                  }
                />
              </PieChart>
            </ResponsiveContainer>{' '}
          </div>
        </div>
      ) : (
        <div className=' text-center mt-20 mb-24 w-full'>No Fee Details</div>
      )}
    </div>
  );
};

export default FeeCollectionProgress;
